import React, { useState, useEffect, useCallback } from 'react';
import {
    Container, Row, Col,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Base from '../Base';
import DatePicker from 'react-datepicker';
import PaginationComponent from '../common/Pagination';
import { FaArrowLeft, FaCalendarAlt } from 'react-icons/fa';
import instance from '../../services/baseService';
const MonthlyRateReport = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage] = useState(10);
    const [selectedMonth, setSelectedMonth] = useState(new Date());
    const [reportData, setReportData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [netTotal, setNetTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handlePagination = (page) => {
        setCurrentPage(page);
    };

    const fetchReportData = useCallback(async () => {
        setLoading(true);

        try {
            const year = selectedMonth.getFullYear();
            const month = selectedMonth.getMonth() + 1;
            const startDate = `${year}-${month.toString().padStart(2, '0')}-01`;
            const response = await instance.post('/api/v1/client/monthly-rates/report', {
                date: startDate,
                page: currentPage,
                perpage: perPage
            });
            if (response.data?.type === "success") {
                setReportData(response.data?.data?.list);
                setTotalCount(response.data?.data?.total_count);
                setNetTotal(response.data?.data?.net_total);
            } else {
                setReportData([]);
                setTotalCount(0);
                setNetTotal(0);
            }
        } catch (error) {
            console.error("Error fetching monthly rate report:", error);
            setReportData([]);
            setTotalCount(0);
            setNetTotal(0);
        }

        setLoading(false);
    }, [currentPage, selectedMonth, perPage]);

    useEffect(() => {
        fetchReportData();
    }, [fetchReportData]);

    const handleMonthSelect = (date) => {
        setSelectedMonth(date);
        setCurrentPage(1);
    };

    const handleBackToHome = () => {
        navigate(-1);
    };

    return (
        <Base>
            <Container fluid>
                <Row>
                    <Col sm={12}>
                        <div className="flex flex-col h-screen">
                            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center bg-white rounded-lg gap-4 mb-4">
                                <div className="d-flex flex-column align-items-start">
                                    <button
                                        variant="link"
                                        className="text-primary d-flex align-items-center gap-2 p-0 mb-2 transition-transform duration-200 hover:scale-105"
                                        onClick={handleBackToHome}
                                        style={{ fontSize: "16px", textDecoration: "none", background: "none", border: "none" }}
                                    >
                                        <FaArrowLeft size={14} /> Back
                                    </button>
                                    <h1 className="m-0 text-[28px] font-bold text-gray-800">Monthly Rate Report</h1>
                                </div>

                                <div className="relative overflow-visible z-10">
                                    <DatePicker
                                        selected={selectedMonth}
                                        onChange={handleMonthSelect}
                                        dateFormat="MMMM yyyy"
                                        showMonthYearPicker
                                        popperPlacement="bottom-end"
                                        calendarClassName="z-50 bg-white rounded-lg shadow-lg border m-2"
                                        customInput={
                                            <button className="flex items-center justify-center text-gray-700 font-semibold text-sm bg-white border border-gray-300 rounded-full px-4 py-2 shadow-sm hover:bg-gray-100 transition w-full sm:w-auto">
                                                <span className="mr-2">
                                                    {selectedMonth.toLocaleString('en-US', { month: 'long', year: 'numeric' })}
                                                </span>
                                                <FaCalendarAlt className="text-primary text-base" />
                                            </button>
                                        }
                                    />
                                </div>
                            </div>

                            {/* Report Table */}
                            <div className="bg-white border-1">
                                {loading ? (
                                    <div className="p-8 text-center text-gray-500 text-lg">
                                        Loading monthly rate report...
                                    </div>
                                ) : reportData.length > 0 ? (
                                    <div className="overflow-x-auto " style={{maxHeight: '750px', overflowY: 'auto' }}>
                                        <table className="w-full text-left ">
                                            <thead className="border-b border-gray-200 sticky top-0 ">
                                                <tr>
                                                    <th className="px-3 py-3 bg-gray-50 ">Client Name</th>
                                                    <th className="px-3 py-3 bg-gray-50 ">Email</th>
                                                    <th className="px-3 py-3 bg-gray-50">Services</th>
                                                    <th className="px-3 py-3 text-center bg-gray-50">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                {reportData.map((client, index) => (
                                                    <tr key={client.id}>
                                                        <td className="px-3 py-2 whitespace-nowrap align-center text-left ">
                                                            {client.clientName}
                                                        </td>
                                                        <td className="px-3 py-2 whitespace-nowrap align-center text-left ">
                                                            {client.email}
                                                        </td>
                                                        <td className="px-3 py-2 whitespace-nowrap">
                                                            <div className="space-y-2">
                                                                {client.services.map((service, serviceIndex) => (
                                                                    <div
                                                                        key={serviceIndex}
                                                                        className="flex justify-between items-center bg-green-100 p-2 mb-2 rounded"
                                                                    >
                                                                        <span className="w-3/4 truncate text-sm text-green-800 text-left">
                                                                            {service.name}
                                                                        </span>
                                                                        <span className="shrink-0 text-right text-sm text-green-800">
                                                                            ₹{service.amount.toLocaleString()}
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </td>
                                                        <td className="px-3 py-4 whitespace-nowrap text-center align-center font-semibold text-gray-700">
                                                            ₹{client.total.toLocaleString()}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot className="bg-gray-100 sticky bottom-0 ">
                                                <tr>
                                                    {!loading  && reportData.length > 0 && (
                                                        <div className="px-3 py-4 text-muted small">
                                                            Showing {reportData.length} of {totalCount} records
                                                        </div>
                                                    )}
                                                    <td
                                                        colSpan={6}
                                                        className="px-3 py-4 font-bold text-gray-700 text-md uppercase text-right"
                                                    >
                                                        Net Total : ₹{netTotal.toLocaleString()}
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="p-8 sm:p-16 lg:p-32 text-center text-gray-500 text-base sm:text-lg">
                                        No data available.
                                    </div>
                                )}
                            </div>
                            {totalCount > perPage && (
                                <Row className="m-2">
                                    <Col md={12} className="d-flex justify-content-center">
                                        <PaginationComponent
                                            total_count={totalCount}
                                            current_page={currentPage}
                                            handleOnClick={handlePagination}
                                            per_page={perPage}
                                        />
                                    </Col>
                                </Row>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </Base>
    );
};

export default MonthlyRateReport;